import {
  Box,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';

import messages from './messages';
import { FormattedMessage } from 'react-intl';

const SurplusCashTooltip = () => (
  <Box>
    <Box>
      <Typography variant="bodySmall" mb={1}>
        <Typography variant="labelMedium">
          <FormattedMessage
            {...messages.complianceItemsPartISurplusCashTooltipSurplusCashLabel}
          />
        </Typography>
        <FormattedMessage
          {...messages.complianceItemsPartISurplusCashTooltipSurplusCashFormula}
        />
      </Typography>
    </Box>
    <Box>
      <Typography variant="bodySmall" mb={1}>
        <Typography variant="labelMedium">
          <FormattedMessage
            {...messages.complianceItemsPartISurplusCashTooltipCashAvailableLabel}
          />
        </Typography>
        <FormattedMessage
          {...messages.complianceItemsPartISurplusCashTooltipCashAvailableFormula}
        />
      </Typography>
    </Box>
    <Box>
      <Typography variant="bodySmall" mb={1}>
        <Typography variant="labelMedium">
          <FormattedMessage
            {...messages.complianceItemsPartISurplusCashTooltipCashRequiredLabel}
          />
        </Typography>
        <FormattedMessage
          {...messages.complianceItemsPartISurplusCashTooltipCashRequiredFormula}
        />
      </Typography>
    </Box>
  </Box>
);

export default SurplusCashTooltip;
